import React, { useEffect, useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Icon,
  IconButton,
  Link,
  makeStyles,
  Paper,
  Typography,
  Box,
  Chip,
  Fade,
  Grow,
  Zoom,
} from "@material-ui/core";

import { useHistory } from "react-router-dom";
import clsx from "clsx";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import { useDispatch, useSelector } from "react-redux";
import { getIncidents } from "../../actions/incidentAction";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    background: theme.palette.type === "dark" 
      ? "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)" 
      : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
    minHeight: "100vh",
  },
  title: {
    color: "#bdbdbd",
  },
  paper: {
    padding: theme.spacing(3),
    background: theme.palette.type === "dark"
      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
      : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#fff",
    borderRadius: 15,
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
    },
  },
  alerts: {
    color: "#fff",
    fontSize: 16,
    fontWeight: 900,
    display: "block",
  },
  alertInfo: {
    fontSize: 13,
    fontWeight: 500,
    display: "block",
    color: "rgba(255,255,255,0.9)",
  },
  grey: {
    color: "#5a5c69",
  },
  alertLink: {
    fontSize: 13,
    fontWeight: 700,
    color: "#fff",
    textDecoration: "underline",
    cursor: "pointer",
  },
  mt20: {
    marginTop: 30,
  },
  card: {
    position: "relative",
    borderRadius: 15,
    overflow: "hidden",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    "&:hover": {
      transform: "translateY(-10px) scale(1.02)",
      boxShadow: "0 12px 40px rgba(0,0,0,0.2)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
      opacity: 0,
      transition: "opacity 0.3s ease",
    },
    "&:hover::before": {
      opacity: 1,
    },
  },
  cardContent: {
    textAlign: "center",
  },
  document: {
    background: "linear-gradient(135deg, #a8c0ff 0%, #3f2b96 100%)",
    color: "#fff",
  },
  
  safety: {
    background: "linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)",
    color: "#fff",
  },
  quality: {
    background: "linear-gradient(135deg,rgb(203, 175, 203) 0%,rgb(109, 12, 131) 100%)",
    color: "#fff",
  },
  attendance: {
    background: "linear-gradient(135deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%)",
    color: "#fff",
  },
  glass: {
    background: "rgba( 255, 255, 255, 0.25 )",
    boxShadow: "0 8px 32px 0 rgba( 31, 38, 135, 0.37 )",
    backdropFilter: "blur(8.0px)",
    WebkitBackdropFilter: "blur(8.0px)",
    borderRadius: "10px",
  },
  hazard: {
    background: "linear-gradient(135deg, #eb3349 0%, #f45c43 100%)",
    color: "#fff",
  },
  project: {
    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    color: "#fff",
  },

  flex: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3),
    position: "relative",
    zIndex: 1,
  },
  icon: {
    width: 50,
    height: 50,
    fill: "#bdbdbd",
    transition: "transform 0.3s ease",
  },
  typo: {
    fontWeight: 900,
    fontSize: 18,
  },
  permit: {
    background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    color: "#fff",
  },
  emergency: {
    background: "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
    color: "#fff",
  },
  statsCard: {
    padding: theme.spacing(2),
    borderRadius: 12,
    background: theme.palette.type === "dark" ? "#2d2d2d" : "#fff",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
    },
  },
  statNumber: {
    fontSize: 32,
    fontWeight: 900,
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  chip: {
    marginTop: 8,
    fontWeight: 600,
  },
  welcomeText: {
    fontSize: 28,
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.type === "dark" ? "#fff" : "#333",
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();

  const { loading, error, incidents } = useSelector((state) => state.incident);
  //const {profile} = useSelector((state) => state.users);

  useEffect(() => {
    dispatch(getIncidents());
  }, [dispatch]);

  useEffect(() => {
    setVisible(true);
  }, []);

  const route = (path) => {
    history.push(path);
  };

  const statsData = [
    { label: "New Inspections", value: 24, trend: "+12%", color: "#667eea" },
    { label: "All Incidents", value: incidents ? incidents.length : 0, trend: "+5%", color: "#f5576c" },
    { label: "Completed Today", value: 15, trend: "+8%", color: "#56ab2f" },
    { label: "Active Users", value: 42, trend: "+2", color: "#f093fb" },
  ];

  return (
    <div className={classes.root}>
      <Fade in={visible} timeout={800}>
        <Box>
          <Typography className={classes.welcomeText}>
            Welcome to DF Barnes Dashboard 👋
          </Typography>
        </Box>
      </Fade>

      <Grow in={visible} timeout={1000}>
        <Paper className={classes.paper}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography
                variant="overline"
                component="small"
                className={classes.alerts}
                gutterBottom
              >
                📢 Alerts & Notifications
              </Typography>
            </Grid>
            <Grid item>
              <IconButton style={{ color: "#fff" }}>
                <Icon className="fas fa-bell" />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography
                variant="overline"
                component="small"
                className={classes.alertInfo}
                gutterBottom
              >
              </Typography>
              <Link href="#" className={classes.alertLink}>
                View all notifications →
              </Link>
            </Grid>
          </Grid>
        </Paper>
      </Grow>

      {/* Statistics Cards */}
      <Grid container spacing={3} style={{ marginBottom: 20, marginTop: 20 }}>
        {statsData.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Zoom in={visible} timeout={600 + index * 200}>
              <Paper className={classes.statsCard}>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  {stat.label}
                </Typography>
                <Typography className={classes.statNumber}>
                  {stat.value}
                </Typography>
                <Chip
                  icon={<TrendingUpIcon />}
                  label={stat.trend}
                  size="small"
                  className={classes.chip}
                  style={{ backgroundColor: stat.color, color: "#fff" }}
                />
              </Paper>
            </Zoom>
          </Grid>
        ))}
      </Grid>

      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        className={classes.mt20}
        spacing={3}
      >
        {[
          { title: "Safety", icon: "fa-shield-alt", color: "safety", path: "/sign", delay: 0 },
          { title: "Quality", icon: "fa-star", color: "quality", path: "/quality", delay: 100 },
          { title: "Documents", icon: "fa-folder-open", color: "document", path: "/document", delay: 200 },
          { title: "Project Execution", icon: "fa-tasks", color: "project", path: "", delay: 300 },
          { title: "Report", icon: "fa-chart-line", color: "hazard", path: "/report", delay: 400 }, 
        ].map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Grow in={visible} timeout={1200 + item.delay}>
              <Card className={clsx(classes.card, classes[item.color])}>
                <CardActionArea
                  className={clsx(classes.flex)}
                  onClick={() => item.path && route(item.path)}
                >
                  <CardContent className={classes.cardContent}>
                    <Typography className={classes.typo}>
                      {item.title}
                    </Typography>
                  </CardContent>

                  <Icon className={`fas ${item.icon}`} style={{ fontSize: 40 }} />
                </CardActionArea>
              </Card>
            </Grow>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Dashboard;
